<div class="flex flex-col w-full">
  <div class="flex items-stretch gap-1.5 w-full">
    <div class="relative w-full max-w-[320px]">
      <input
        type="text"
        [(ngModel)]="searchText"
        (focus)="onInputFocus()"
        (click)="onInputClick()"
        [placeholder]="placeholder"
        class="w-full px-2.5 py-1.5 pr-7 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate"
      />
      <lucide-icon name="search" [size]="12" class="absolute right-2 top-1/2 -translate-y-1/2 text-[#8a94a0] pointer-events-none"></lucide-icon>

      <div
        *ngIf="isOpen && filteredOptions.length > 0"
        class="absolute top-full left-0 mt-1 bg-white border border-[#e8edf3] rounded-lg shadow-[0_12px_32px_rgba(40,56,66,0.22)] z-50 max-h-60 overflow-y-auto overflow-x-hidden py-1 min-w-full w-max"
        style="min-width: 240px;"
      >
        <ng-container *ngIf="!hasGroups">
          <div
            *ngFor="let option of filteredOptions"
            (mousedown)="selectOption(option); $event.preventDefault()"
            class="px-3 py-1.5 text-[13px] cursor-pointer text-corporate-3 transition-colors duration-150 hover:bg-hover-2"
          >
            {{option.label}}
          </div>
        </ng-container>

        <ng-container *ngIf="hasGroups">
          <ng-container *ngFor="let group of filteredGroups">
            <div class="px-3 py-1 text-[11px] font-bold text-[#8a94a0] uppercase tracking-wide">{{group.label}}</div>
            <div
              *ngFor="let option of group.items"
              (mousedown)="selectOption(option); $event.preventDefault()"
              class="px-3 py-1.5 text-[13px] cursor-pointer text-corporate-3 transition-colors duration-150 hover:bg-hover-2"
            >
              {{option.label}}
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div
        *ngIf="isOpen && filteredOptions.length === 0"
        class="absolute top-full left-0 mt-1 bg-white border border-[#e8edf3] rounded-lg shadow-[0_12px_32px_rgba(40,56,66,0.22)] z-50 py-2 px-3 min-w-full"
        style="min-width: 240px;"
      >
        <span class="text-[12px] text-[#8a94a0] italic">Sin resultados</span>
      </div>
    </div>

    <button
      type="button"
      (click)="clearAll()"
      class="flex items-center justify-center gap-1 px-2.5 rounded-lg text-[#5a6b7a] border border-[#d4dde6] bg-white cursor-pointer transition-all hover:bg-hover-2 hover:border-corporate hover:text-corporate shrink-0 text-[12px] font-medium self-stretch"
    >
      <lucide-icon name="eraser" [size]="14"></lucide-icon>
      Limpiar
    </button>
  </div>

  <div *ngIf="selectedItems.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-2">
    <div *ngFor="let item of selectedItems" class="relative inline-flex w-full">
      <div class="inline-flex items-center w-full px-3 pr-5 py-1.5 text-[13px] font-medium text-corporate-3 bg-[#f0f4f8] border border-[#d4dde6] rounded-lg truncate">
        {{item.label}}
      </div>
      <a
        (click)="removeItem(item)"
        class="absolute -top-1.5 -right-1.5 flex items-center justify-center w-5 h-5 bg-white border border-[#d4dde6] rounded-full text-[#667] cursor-pointer shadow-sm transition-all hover:bg-red-50 hover:text-red-500 hover:border-red-300"
      >
        <lucide-icon name="x" [size]="12"></lucide-icon>
      </a>
    </div>
  </div>
</div>